<template>
  <MainHeader></MainHeader>
  <div id="outer-wrap">
    <div id="inner-wrap">
      <router-view></router-view>
    </div>
  </div>
  <MainFooter></MainFooter>
</template>

<script>
import MainHeader from '@/components/Common/MainHeader.vue';
import MainFooter from '@/components/Common/MainFooter.vue';

export default {
  components: {
    MainHeader,
    MainFooter
  }
};
</script>
